import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  fusionStoreToken,
  TaskWorkspaceStore,
} from '../../../../../../../core/h3ml/state/task-workspace-store';
import { ShapeState } from '../../../../../../../cross-team-shared/annotation/shared/state/shape-state';

@Component({
  selector: 'h3-shape-subpoint-count',
  templateUrl: './shape-subpoint-count.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShapeSubpointCountComponent implements OnInit {
  @Input({ required: true }) shape!: ShapeState;
  subpointCount$!: Observable<number>;
  subpointCountMapping = {
    '=0': 'No subpoints',
    '=1': '1 subpoint',
    other: '# subpoints',
  };

  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private fusionStore = inject(fusionStoreToken);

  ngOnInit() {
    const frameNumber$ = this.fusionStore('frameNumber').$;

    assert(
      this.shape.outputName,
      'all shapes in object enabled projects should have an output name',
    );

    const keyLocations$ = this.taskWorkspaceStore('outputAnnotationInfo')(
      this.shape.outputName,
      // @ts-ignore -- fix me
    )('shapes')(this.shape.index)('key_locations').$;

    this.subpointCount$ = combineLatest([frameNumber$, keyLocations$]).pipe(
      filter(([_, keyLocations]) => isDefined(keyLocations)),
      map(
        ([frameNumber, keyLocations]) =>
          // @ts-ignore -- fix me
          keyLocations.find(
            // @ts-ignore -- fix me
            (keyLocation) => keyLocation.frame_number === frameNumber,
          )?.points.length ?? 0,
      ),
    );
  }
}
